import { useEffect } from 'react';

interface UseGalleryVisibilityProps {
  isShowingProducts: boolean;
}

export const useGalleryVisibility = ({
  isShowingProducts,
}: UseGalleryVisibilityProps): void => {
  useEffect(() => {
    const caddieRoot = document.getElementById('caddie-root');
    if (!caddieRoot) return;

    if (isShowingProducts) {
      caddieRoot.classList.add('caddie-root-showing-gallery');
    } else {
      caddieRoot.classList.remove('caddie-root-showing-gallery');
    }

    return () => {
      if (caddieRoot) {
        caddieRoot.classList.remove('caddie-root-showing-gallery');
      }
    };
  }, [isShowingProducts]);
};
